<template>
  <div>
    <base-form @click="updateVehicule" :statut="statut" :loading="loading">
      <BaseToolBar
        title="Affectations"
        subtitle="Liste des affectations pour ce véhicule"
      >
        <BaseButton
          class="btn btn-primary ml-3"
          v-tooltip="'Ajouter une affectation'"
          @click="affectCollaborateur"
          :loading="loading"
          icon="plus"
          text="Ajouter"
        ></BaseButton>
      </BaseToolBar>

      <!-- Liste des affectations -->
      <div
        v-for="(affectation, index) in vehicule.collaborateurs"
        :key="affectation.id || 'new_' + index"
        class="card mb-3"
      >
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h6 class="mb-0">
            Affectation {{ index + 1 }}
            <span
              v-if="affectation.collaborateur"
              class="badge badge-info ml-2"
            >
              {{ affectation.collaborateur.collaborateur_nom }}
              {{ affectation.collaborateur.collaborateur_prenom }}
            </span>
          </h6>
          <ButtonCircle
            name="trash"
            @click="deleteAffectation(affectation)"
            class="m-1"
            :loading="loading"
          ></ButtonCircle>
        </div>
        <div class="card-body">
          <base-form-row row>
            <select-collaborateur
              class="mb-2"
              v-model.number="affectation.collaborateur_id"
              text="Collaborateur"
            ></select-collaborateur>
          </base-form-row>
          <base-form-row row>
            <base-inputDatePicker
              v-model="affectation.date_affectation"
              inputText="Date d'affectation"
            ></base-inputDatePicker>
            <base-inputDatePicker
              v-model="affectation.date_restitution"
              inputText="Date de restitution"
            ></base-inputDatePicker>
          </base-form-row>
          <base-form-row row>
            <base-input
              v-model="affectation.kms_parcourus"
              inputText="Kilomètres parcourus"
              type="number"
            ></base-input>
            <base-select
              inputText="Type d'affectation"
              v-model.number="affectation.categorie_id"
              :options="data.categoriesAffectation"
            ></base-select>
          </base-form-row>
          <base-form-row row>
            <Checkbox
              v-model="affectation.doc_signe"
              text="Document signé"
            ></Checkbox>
          </base-form-row>
          <base-form-row>
            <uploader
              v-if="affectation.id"
              :id="'doc_vehicule_affectations_' + affectation.id"
              url="/upload/document"
              file_system="VEHICULES_AFFECTATIONS"
              file_field="affectation"
              :file_key="affectation.id"
              title="Pièces jointes"
            ></uploader>
            <div v-else class="alert alert-warning">
              <i class="fas fa-info-circle mr-2"></i>
              Veuillez d'abord enregistrer cette affectation pour pouvoir
              ajouter des pièces jointes.
            </div>
          </base-form-row>
        </div>
      </div>

      <div v-if="vehicule.collaborateurs.length === 0" class="alert alert-info">
        Ce véhicule n'a pas encore d'affectation. Cliquez sur "Ajouter" pour
        affecter un collaborateur.
      </div>

      <BaseToolBar
        class="mt-4"
        title="Affectations aux établissements"
        subtitle="Liste des établissements associés"
      >
        <BaseButton
          class="btn btn-primary ml-3"
          v-tooltip="'Ajouter une affectation établissement'"
          @click="affectEtablissement"
          :loading="loading"
          icon="plus"
          text="Ajouter"
        ></BaseButton>
      </BaseToolBar>

      <!-- Liste des affectations établissements -->
      <div
        v-for="(affectation, index) in vehicule.etablissements"
        :key="affectation.id || 'etab_new_' + index"
        class="card mb-3"
      >
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h6 class="mb-0">
            Établissement {{ index + 1 }}
            <span
              v-if="getEtablissementName(affectation.etablissement_id)"
              class="badge badge-info ml-2"
            >
              {{ getEtablissementName(affectation.etablissement_id) }}
            </span>
          </h6>
          <ButtonCircle
            name="trash"
            @click="deleteAffectationEtablissement(affectation)"
            class="m-1"
            :loading="loading"
          ></ButtonCircle>
        </div>
        <div class="card-body">
          <base-form-row row>
            <base-select
              inputText="Établissement"
              v-model.number="affectation.etablissement_id"
              :options="data.etablissements || []"
            ></base-select>
          </base-form-row>
          <base-form-row row>
            <base-inputDatePicker
              v-model="affectation.date_debut"
              inputText="Date de début"
            ></base-inputDatePicker>
            <base-inputDatePicker
              v-model="affectation.date_fin"
              inputText="Date de fin"
            ></base-inputDatePicker>
          </base-form-row>
        </div>
      </div>

      <div v-if="vehicule.etablissements.length === 0" class="alert alert-info">
        Ce véhicule n'est associé à aucun établissement. Cliquez sur "Ajouter"
        pour ajouter un établissement.
      </div>
    </base-form>
  </div>
</template>

<script>
import BaseToolBar from "@/components/bases/ToolBar.vue";
import BaseForm from "@/components/bases/Form.vue";
import BaseFormRow from "@/components/bases/FormRow.vue";
import BaseInput from "@/components/bases/Input.vue";
import BaseSelect from "@/components/bases/Select.vue";
import BaseInputDatePicker from "@/components/bases/InputDatePicker.vue";
import Checkbox from "@/components/bases/Checkbox.vue";
import SelectCollaborateur from "@/components/bases/SelectCollaborateur.vue";
import BaseButton from "@/components/bases/Button.vue";
import ButtonCircle from "@/components/bases/ButtonCircle.vue";
import Uploader from "@/components/bases/Uploader.vue";

export default {
  name: "VehiculeAffectations",
  components: {
    BaseToolBar,
    BaseForm,
    BaseFormRow,
    BaseInput,
    BaseSelect,
    BaseInputDatePicker,
    SelectCollaborateur,
    BaseButton,
    ButtonCircle,
    Checkbox,
    Uploader
  },
  props: {
    vehicule: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    statut: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateVehicule() {
      this.$emit("update-vehicule", this.vehicule);
    },
    affectCollaborateur() {
      this.vehicule.collaborateurs.unshift({
        collaborateur_id: null,
        date_affectation: null,
        date_restitution: null,
        kms_parcourus: 0,
        categorie_id: null,
        doc_signe: false
      });
    },
    affectEtablissement() {
      this.vehicule.etablissements.unshift({
        etablissement_id: null,
        date_debut: null,
        date_fin: null
      });
    },
    deleteAffectation(affectation) {
      if (
        !window.confirm(
          "Êtes-vous sûr de vouloir supprimer cette affectation ?"
        )
      )
        return;

      if (!affectation.id) {
        // Si c'est une nouvelle affectation non encore sauvegardée
        const index = this.vehicule.collaborateurs.findIndex(
          x => x === affectation
        );
        if (index !== -1) {
          this.vehicule.collaborateurs.splice(index, 1);
        }
        return;
      }

      this.$emit("delete-affectation", affectation);
    },
    deleteAffectationEtablissement(affectation) {
      if (
        !window.confirm(
          "Êtes-vous sûr de vouloir supprimer cette affectation d'établissement ?"
        )
      )
        return;

      if (!affectation.id) {
        // Si c'est une nouvelle affectation non encore sauvegardée
        const index = this.vehicule.etablissements.findIndex(
          x => x === affectation
        );
        if (index !== -1) {
          this.vehicule.etablissements.splice(index, 1);
        }
        return;
      }

      this.$emit("delete-affectation-etablissement", affectation);
    },
    getEtablissementName(etablissementId) {
      if (!this.data.etablissements || !etablissementId) return null;

      const etablissement = this.data.etablissements.find(
        e => e.id === etablissementId
      );
      return etablissement ? etablissement.description : null;
    }
  }
};
</script>

<style scoped>
.card-header {
  background-color: #f8f9fa;
}
.badge-info {
  background-color: #17a2b8;
}
</style>
